import React from "react";
import { Flex, Icon, Text, useColorModeValue } from "@chakra-ui/react";
import { MdPendingActions } from "react-icons/md";
import Card from "horizon/components/card/Card";

/**
 * Builds the subtitle text from the current page items / hasMore flag.
 * @param {number} count - Items on the current page
 * @param {boolean} hasMore - Whether more pages exist
 * @returns {string}
 */
function buildSubtitle(count, hasMore) {
  if (count === 0) return "Aucun paiement en attente d'approbation";
  const plural = count > 1 ? "s" : "";
  const suffix = hasMore ? " (page courante)" : "";
  return `${count} paiement${plural} à valider${suffix}`;
}

/**
 * Renders the page header card with icon, title and a dynamic subtitle.
 * @param {Object} props - count (number), hasMore (boolean)
 * @returns {React.ReactElement}
 */
function TransactionsHeader({ count, hasMore }) {
  const titleColor = useColorModeValue("secondaryGray.900", "white");
  const subColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
  const badgeBg = useColorModeValue("orange.50", "whiteAlpha.100");
  return (
    <Card>
      <Flex align="center" gap="14px">
        <Flex align="center" justify="center" w="44px" h="44px" borderRadius="12px" bg={badgeBg}>
          <Icon as={MdPendingActions} w="22px" h="22px" color="orange.400" />
        </Flex>
        <Flex direction="column" minW="0">
          <Text fontSize="lg" fontWeight="700" color={titleColor}>Paiements à valider</Text>
          <Text fontSize="sm" color={subColor} noOfLines={1}>{buildSubtitle(count, hasMore)}</Text>
        </Flex>
      </Flex>
    </Card>
  );
}

export default TransactionsHeader;
